import React from 'react';
import classNames from 'classnames';

import {
  Container,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

const NodeBasicPage = ({ entity, className }) => {
  const classes = classNames(className, 'BasicPage');

  return (
    <article typeof="schema:WebPage" className={classes}>
      <Container>
        <div className="BasicPage">
          {entity.getIn(['body', 0, 'processed']) ? (
            <div className="row">
              <WysiwygField
                property="schema:text"
                className="node--basic-page--body offset-md-1 offset-lg-2 col-xs-12 col-sm-12 col-md-10 col-lg-8 col-xl-8"
                html={entity.getIn(['body', 0, 'processed'], '')}
              />
            </div>
          ) : null}
        </div>
      </Container>
    </article>
  );
};

export default NodeBasicPage;
